import React, { Component } from "react";
import { Tag, Select } from "antd";
import PropTypes from "prop-types";
var _ = require("lodash");
const Option = Select.Option;

class UserFilterInput extends Component {
  onChange = ele => {
    this.props.onFilterSet({ selectedOptions: ele, operator: "contains" });
  };

  render() {
    let users = this.props.projectMembers;
    let showNoneAsOption =
      this.props.showNoneAsOption != undefined &&
      this.props.showNoneAsOption === true
        ? true
        : false;
    if (users && Array.isArray(users) && users.length) {
      users.sort(function(a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
    }
    return (
      <Select
        //mode="multiple"
        style={{ width: "100%" }}
        placeholder="Please select"
        defaultValue={this.props.filterOptions.selectedOptions}
        value={this.props.filterOptions.selectedOptions}
        onChange={this.onChange}
      >
        {showNoneAsOption ? (
          <Option key={0} value={"0"}>
            Unassigned
          </Option>
        ) : null}
        {_.map(users, function(user) {
          return (
            <Option key={user.id} value={user.id.toString()}>
              {user.name}
            </Option>
          );
        })}
      </Select>
    );
  }
}

export default UserFilterInput;
